import useLogger from "./useLogger";
import usePortalType from "./usePortalType";

const useTrackLogin = () => {
  const logger = useLogger();
  const portalType = usePortalType();

  return (user) => {
    logger.trackEvent("Login", {
      portal: portalType ?? "",
      roleName: user?.role?.roleName ?? "",
      userName: user?.userName ?? "",
    });
  };
};

export default useTrackLogin;
